import { getDownstreamHostsValue } from "@swiggy-private/checkout-core";

export const DOWNSTREAM_HOSTS = {
    DO_HOST: getDownstreamHostsValue("DO_HOST") ?? "https://dinersone-proxy.swiggy.com",
    GROWTHX_API_HOST: getDownstreamHostsValue("GROWTHX_API_HOST") ?? "https://spns.swiggy.com",
    GANDALF_HOST: getDownstreamHostsValue("CART_HABIT_FORMING_HOST") ?? "https://disc.swiggy.com",
};

export const DOWNSTREAM_ENDPOINTS = {
    APPLY_COUPON_ENDPOINT: "/api/v2/view/apply-coupon/{0}?cartType={1}",
    UPDATE_CART_ENDPOINT: "/api/v2/view/DINEOUT",
    GROWTHX_POLLING: "/api/v1/dineout/pool/external/poll",
    CREATE_PAYMENT_LINK_URI: "/api/v1/dash/payment/payment-link/serviceLine",
    FETCH_COUPONS:
        "/api/v3/BUSINESS_LINE_DINEOUT/offer/json?lat={0}&lng={1}&source_page=cart&restaurant_id={2}&cart_value={3}&dealCategory={4}&entityId={5}&isPartPaySelected={6}&tableId={7}",
    VALIDATE_CART_ENDPOINT: "/api/v2/view?cartType={0}",
    FETCH_STEALDEAL_ITEM_OUTLET_VALIDITY_ENDPOINT: "/api/v2/view/getOutlets/?id={0}&cartId={1}",
};
